export enum EMediaPermissionsErrorType {
  /** (macOS) browser does not have permission to access cam/mic */
  SYSTEM_PERMISSION_DENIED = 'SystemPermissionDenied',
  /** user denied permission for site to access cam/mic */
  USER_PERMISSION_DENIED = 'UserPermissionDenied',
  /** (Windows) browser does not have permission to access cam/mic OR camera is in use by another application or browser tab */
  COULD_NOT_START_VIDEO_SOURCE = 'CouldNotStartVideoSource',
  /** all other errors */
  GENERIC = 'Generic',
}

export type TMediaPermissionsError = {
  type?: EMediaPermissionsErrorType;
  name: string;
  message?: string;
};
